import { EntityClientCaseWizard } from "./EntityClientCaseWizard";
import { EntityClientWizardProvider } from "./EntityClientCaseWizard/context";
import type { OnboardingCaseType } from "./EntityClientCaseWizard/types";

export type { OnboardingCaseType };

export const EntityClientCaseNavigation = ({ caseType }: { caseType: OnboardingCaseType }) => (
  <EntityClientWizardProvider caseType={caseType}>
    <EntityClientCaseWizard />
  </EntityClientWizardProvider>
);
